export enum FormStatus {
  Initial = 'initial',
  Pending = 'pending',
  Success = 'success',
  NoContent = 'noContent',
  Error = 'error',
}

export interface FormEvent {
  readonly formId: string;

  readonly status: FormStatus;

  readonly error?: Error;

  readonly submitted: boolean;
}
